import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { IJobsProps } from "../types";

export const QUERY_KEY_FOR_JOBS = "jobs";

// TO DO : need to exist in the general data entities and refactored
interface IGetDataProps {
  pagination?: {
    pageSize?: number;
    current?: number;
  };
  token?: string;
  userInfo?: any;
  recruiter_id?: string;
  search?: string;
  start_date?: string | null;
  end_date?: string | null;
  work_model?: string | null;
  location_country?: string | null;
  location_city?: string | null;
  title?: string | null;
  employment_type?: string | null;
  closed?: string | null;
  experience_level?: string | null;
  sector?: string | null;
  jobposted?: string | null;
  liked_by_user?: 0 | 1;
  bookmarked_by_user?: 0 | 1;
}


const getData = async (
  props: IGetDataProps
): Promise<{ data: IJobsProps[]; total: number }> => {
  const {
    pagination,
    search,
    recruiter_id,
    end_date,
    start_date,
    work_model,
    location_country,
    location_city,
    title,
    employment_type,
    closed,
    experience_level,
    sector,
    jobposted,
    liked_by_user,
    bookmarked_by_user
  } = props;

  const corporate_id = props?.userInfo?.current_team ? props?.userInfo?.current_team.corporate_id : '';
  const url = `${END_POINT.BASE_URL}/v1/jobs${recruiter_id?'/'+recruiter_id:''}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
    params: {
      q: search,
      page: pagination?.current,
      limit: pagination?.pageSize,
      end_date,
      start_date,
      work_model,
      location_country,
      location_city,
      title,
      employment_type,
      closed,
      experience_level,
      sector,
      jobposted,
      corporate_id,
      liked_by_user,
      bookmarked_by_user
    },
  };

  const res = await axios.get(url, config);

  const fetchedData = res.data.data;
  const data: IJobsProps[] = fetchedData.map(
    (item: IJobsProps): IJobsProps => ({ ...item })
  );
  return {
    data,
    total: res.data.total,
  };
};


export const useGetJobs = ({
  pagination,
  search,
  end_date,
  start_date,
  work_model,
  location_country,
  location_city,
  title,
  employment_type,
  closed,
  experience_level,
  sector,
  jobposted,
  liked_by_user,
  bookmarked_by_user
}: IGetDataProps) => {
  const { token, userInfo } = useGetUserInfo();
  const queryData = useQuery(
    [
      QUERY_KEY_FOR_JOBS,
      {
        page: pagination?.current ?? 1,
        limit: pagination?.pageSize ?? 10,
        search: search ?? '',
        end_date: end_date ?? '',
        start_date: start_date ?? '',
        work_model: work_model ?? '',
        location_country: location_country ?? '',
        location_city: location_city ?? '',
        title: title ?? '',
        employment_type: employment_type ?? '',
        closed: closed ?? '',
        experience_level: experience_level ?? '',
        sector: sector ?? '',
        jobposted: jobposted ?? '',
        liked_by_user: liked_by_user ?? '',
        bookmarked_by_user: bookmarked_by_user ?? '',
      },
    ],
    () =>
      getData({
        search,
        pagination,
        token,
        userInfo,
        recruiter_id: userInfo?.recruiter ? userInfo?.recruiter?.id : '',
        end_date,
        start_date,
        work_model,
        location_country,
        location_city,
        title,
        employment_type,
        closed,
        experience_level,
        sector,
        jobposted,
        liked_by_user,
        bookmarked_by_user
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: (err: any) => { },
      onSuccess: (data) => { },
    }
  );

  return queryData;
};
